/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DeviceStatisticsResponse } from '../models/device-statistics-response';

@Injectable({
  providedIn: 'root',
})
export class DeviceStatsControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getDeviceStats
   */
  static readonly GetDeviceStatsPath = '/api/v1/device/{deviceId}/stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeviceStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceStats$Response(params: {
    deviceId: string;
    interval?: number;
  }): Observable<StrictHttpResponse<DeviceStatisticsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceStatsControllerService.GetDeviceStatsPath, 'get');
    if (params) {
      rb.path('deviceId', params.deviceId, {});
      rb.query('interval', params.interval, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeviceStatisticsResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDeviceStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceStats(params: {
    deviceId: string;
    interval?: number;
  }): Observable<DeviceStatisticsResponse> {

    return this.getDeviceStats$Response(params).pipe(
      map((r: StrictHttpResponse<DeviceStatisticsResponse>) => r.body as DeviceStatisticsResponse)
    );
  }

  /**
   * Path part for operation getDeviceParameter
   */
  static readonly GetDeviceParameterPath = '/api/v1/device/{deviceId}/parameters';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeviceParameter()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceParameter$Response(params: {
    deviceId: string;
  }): Observable<StrictHttpResponse<{
[key: string]: {
};
}>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceStatsControllerService.GetDeviceParameterPath, 'get');
    if (params) {
      rb.path('deviceId', params.deviceId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        [key: string]: {
        };
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDeviceParameter$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceParameter(params: {
    deviceId: string;
  }): Observable<{
[key: string]: {
};
}> {

    return this.getDeviceParameter$Response(params).pipe(
      map((r: StrictHttpResponse<{
[key: string]: {
};
}>) => r.body as {
[key: string]: {
};
})
    );
  }

}
